import { Col, Form, Input, Modal, Row } from 'antd';
import { localize } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React, { FC } from 'react';

const RegVerificationModal: FC<any> = (props: any) => {
    return (
        <Modal
            open={props.open}
            onCancel={props.close}
            footer={
                <Row
                    justify="end"
                    gutter={15}
                    className="pt-3"
                >
                    <Col>
                        <Button
                            type="primary"
                            color="gold"
                            onClick={props.onOk}
                            loading={props.isRestoring}
                        >
                            {localize('button.send', props.translations)}
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={props.close}>
                            {localize('button.close', props.translations)}
                        </Button>
                    </Col>
                </Row>
            }
        >
            <div className="my-3">
                <h5>{localize('block-auth-enter-confirmation-code', props.translations)}</h5>

                <Form
                    form={props.form}
                    layout="vertical"
                >
                    <Form.Item
                        label={localize('block-auth-test-code', props.translations)}
                        name="confirmCode"
                        rules={[
                            {
                                required: true,
                                message: localize('block-auth-required-field', props.translations),
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    {props.reset && (
                        <>
                            <Form.Item
                                label={localize('block-auth-new-password', props.translations)}
                                name="newPassword"
                                rules={[
                                    {
                                        required: true,
                                        message: localize(
                                            'block-auth-required-field',
                                            props.translations
                                        ),
                                    },
                                    {
                                        pattern:
                                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                        message: localize(
                                            'block-auth-incorrect-password-format',
                                            props.translations
                                        ),
                                    },
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>
                            <Form.Item
                                label={localize('block-auth-repeat-password', props.translations)}
                                name="repeatPassword"
                                rules={[
                                    {
                                        required: true,
                                        message: localize(
                                            'block-auth-required-field',
                                            props.translations
                                        ),
                                    },
                                    {
                                        pattern:
                                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                        message: localize(
                                            'block-auth-incorrect-password-format',
                                            props.translations
                                        ),
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('newPassword') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(
                                                new Error(
                                                    localize(
                                                        'password-not-equal',
                                                        props.translations
                                                    )
                                                )
                                            );
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>
                        </>
                    )}
                </Form>
            </div>
        </Modal>
    );
};

export default RegVerificationModal;
